import { useContext, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { Info } from '@mui/icons-material'
import { ButtonBase, Typography, useTheme } from '@mui/material'

import { DashboardContext } from '../../../providers/dashboard-provider'
import useStyles from '../index.styles'

import AudibleAlarmOnlyModal from './audible-alarm-only-modal'
import ChipInfoDrawer from './chip-info-drawer'
import SlimConnectingModal from './slim-connecting-modal'

const StatusChip = ({
  status,
  deviceId,
}: {
  status: 'urgent-alert-action-needed' | 'urgent-alert-on-it' | 'urgent-alert-ignored' | 'slim-connecting' | 'slim-audible-only'
  deviceId?: string | number
}) => {
  const classes = useStyles
  const navigate = useNavigate()
  const location = useLocation()
  const { selectedFolderId } = useContext(DashboardContext)
  const theme = useTheme()
  const isActionNeeded = status === 'urgent-alert-action-needed'
  const [showInfoDrawer, setShowInfoDrawer] = useState(false)
  const [audibleOnlyModalVisible, setAudibleOnlyModalVisible] = useState(false)
  const [slimConnectingModalVisible, setSlimConnectingModalVisible] = useState(false)

  return (
    <>
      <ButtonBase
        sx={classes.statusChipButton(isActionNeeded, theme)}
        onClick={() => {
          if (status === 'urgent-alert-action-needed') {
            if (deviceId !== undefined) {
              navigate({
                pathname: selectedFolderId ? `/dashboard/${selectedFolderId}/devices/${deviceId}` : '/dashboard',
                hash: location.hash,
                search: location.search,
              })
            }
            return
          }
          if (status === 'slim-connecting') {
            setSlimConnectingModalVisible(true)
            return
          }
          if (status === 'slim-audible-only') {
            setAudibleOnlyModalVisible(true)
            return
          }
          setShowInfoDrawer(true)
        }}
      >
        <Typography variant="overline" sx={classes.statusChipText(isActionNeeded, theme)}>
          {status === 'urgent-alert-action-needed' && 'Action needed'}
          {status === 'urgent-alert-on-it' && 'Being handled'}
          {status === 'urgent-alert-ignored' && 'Ignored'}
          {status === 'slim-connecting' && 'Connecting...'}
          {status === 'slim-audible-only' && 'Audio-only'}
        </Typography>
        {status !== 'urgent-alert-action-needed' && status !== 'slim-connecting' && (
          <Info fontSize="small" sx={classes.statusChipInfoIcon} aria-label="Why am I seeing this?" />
        )}
      </ButtonBase>

      <ChipInfoDrawer open={showInfoDrawer} setOpen={setShowInfoDrawer} />
      <AudibleAlarmOnlyModal audibleOnlyModalVisible={audibleOnlyModalVisible} setAudibleOnlyModalVisible={setAudibleOnlyModalVisible} />
      <SlimConnectingModal modalVisible={slimConnectingModalVisible} setModalVisible={setSlimConnectingModalVisible} />
    </>
  )
}

export default StatusChip
